import React, { useState } from 'react';
import { CheckCircle2Icon, ClockIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
const hours = [{
  day: 'Mardi — vendredi',
  value: '9 h — 12 h · 14 h — 18 h'
}, {
  day: 'Samedi',
  value: '9 h — 13 h'
}, {
  day: 'Dimanche & lundi',
  value: 'Fermé'
}];
export function Contact() {
  const [sent, setSent] = useState(false);
  return <div className="mx-auto grid max-w-page gap-14 px-5 py-14 lg:grid-cols-[1fr_1.1fr] lg:px-8" data-id="element-136" data-mp="1loffi2rng7um">
      <div data-id="element-137" data-mp="xycozr3dv9y4">
        <h1 className="font-display text-4xl leading-tight text-ink sm:text-5xl" data-id="element-138" data-mp="t1md7fym30ii">Nous écrire</h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-muted" data-id="element-139" data-mp="17qihr31glved">
          Une question sur une commande, un groupe à accueillir, une toison à faire filer ? Audrey
          répond sous 48 h.
        </p>

        <dl className="mt-10 space-y-5 text-sm" data-id="element-140" data-mp="f9o8dhbxnqs5">
          <div className="flex gap-3" data-id="element-141" data-mp="f8d5djqban23">
            <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-olive" aria-hidden="true" data-id="element-142" data-mp="abcxr4dtdc8v" />
            <div data-id="element-143" data-mp="15ff2fs6we14j">
              <dt className="font-medium text-ink" data-id="element-144" data-mp="15fyonl3kzbod">Adresse</dt>
              <dd className="mt-1 text-muted" data-id="element-145" data-mp="15dcd7adkkc0v">Lieu-dit Bru de la Roque, 12520 Aveyron</dd>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-146" data-mp="1e80l78aj47td">
            <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-olive" aria-hidden="true" data-id="element-147" data-mp="1e91wndvgiwbm" />
            <div data-id="element-148" data-mp="1j5scc03cnpwi">
              <dt className="font-medium text-ink" data-id="element-149" data-mp="1j6bvfk4qkkc4">Téléphone</dt>
              <dd className="mt-1 text-muted" data-id="element-150" data-mp="mhckfxcrp4g8">05 65 00 00 00</dd>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-151" data-mp="qhmsdfk4e4xq">
            <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-olive" aria-hidden="true" data-id="element-152" data-mp="qig0ajutf0hg" />
            <div data-id="element-153" data-mp="vfo8brm91o4z">
              <dt className="font-medium text-ink" data-id="element-154" data-mp="vjc3ev7ceilt">E-mail</dt>
              <dd className="mt-1 text-muted" data-id="element-155" data-mp="10hdjr8ddw3tl">contact@brudelaroque.fr</dd>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-156" data-mp="26vmmg9wab0d2">
            <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-olive" aria-hidden="true" data-id="element-157" data-mp="26ysbxq8ts49b" />
            <div data-id="element-158" data-mp="2bxlq7kvxrzaj">
              <dt className="font-medium text-ink" data-id="element-159" data-mp="1m7dajaixl9eb">Boutique à la ferme</dt>
              <dd className="mt-1 space-y-1 text-muted" data-id="element-160" data-mp="1m9gc8rtg4qyv">
                {hours.map(slot => <p key={slot.day} data-id="element-161" data-mp="1had5n2xticos">
                    <span className="text-ink" data-id="element-162" data-mp="1w59osb760kgn">{slot.day}</span> · {slot.value}
                  </p>)}
              </dd>
            </div>
          </div>
        </dl>
      </div>

      <div className="rounded-lg border border-line bg-parchment p-6 sm:p-8" data-id="element-163" data-mp="13gm68ndsw96s">
        {sent ? <div className="flex h-full min-h-[22rem] flex-col items-center justify-center gap-3 text-center" data-id="element-164" data-mp="yi14ukmtbjgr">
            <CheckCircle2Icon className="h-9 w-9 text-olive" aria-hidden="true" data-id="element-165" data-mp="1d772w59wz3n2" />
            <p className="font-display text-xl text-ink" data-id="element-166" data-mp="18fyth98l3i9w">Message envoyé</p>
            <p className="max-w-xs text-sm text-muted" data-id="element-167" data-mp="18dvrrry2k0pc">
              Merci ! Audrey vous répond sous 48 h, du mardi au samedi.
            </p>
            <button type="button" onClick={() => setSent(false)} className="mt-2 text-sm text-olive hover:text-olive-dark" data-id="element-168" data-mp="frt8cldmbr9j">
              Écrire un autre message
            </button>
          </div> : <form className="space-y-5" onSubmit={event => {
        event.preventDefault();
        setSent(true);
      }} data-id="element-169" data-mp="2w76df37zl3yv">
            <h2 className="font-display text-xl text-ink" data-id="element-170" data-mp="2mftho0j2htnk">Formulaire de contact</h2>
            <div className="grid gap-5 sm:grid-cols-2" data-id="element-171" data-mp="3a6fo5ndfb5vg">
              <Field label="Nom" id="nom" data-id="element-172" data-mp="3f3z4cstolsq1" />
              <Field label="E-mail" id="email" type="email" data-id="element-173" data-mp="3f3pdz44q5jjt" />
            </div>
            <Field label="Sujet" id="sujet" data-id="element-174" data-mp="313elxxrohyx2" />
            <div data-id="element-175" data-mp="316j0np2rsd1z">
              <label htmlFor="message" className="text-sm font-medium text-ink" data-id="element-176" data-mp="3561kehiuui38">
                Message
              </label>
              <textarea id="message" required rows={6} className="mt-2 w-full rounded-md border border-line bg-cream px-3 py-2.5 text-sm text-ink placeholder:text-muted/60 focus:border-olive focus:outline-none focus:ring-1 focus:ring-olive" placeholder="Bonjour Audrey, …" data-id="element-177" data-mp="1pp1axti0xdyg" />
            </div>
            <button type="submit" className="w-full rounded-full bg-olive py-3 text-sm font-medium text-cream transition-colors duration-150 ease-soft hover:bg-olive-dark sm:w-auto sm:px-8" data-id="element-178" data-mp="207ofcpdsi4ot">
              Envoyer
            </button>
          </form>}
      </div>
    </div>;
}
function Field({
  label,
  id,
  type = 'text'
}: {
  label: string;
  id: string;
  type?: string;
}) {
  return <div data-id="element-179" data-mp="2ixe4owys9y9c">
      <label htmlFor={id} className="text-sm font-medium text-ink" data-id="element-180" data-mp="2ix4ilkgv0b8x">
        {label}
      </label>
      <input id={id} type={type} required className="mt-2 w-full rounded-md border border-line bg-cream px-3 py-2.5 text-sm text-ink focus:border-olive focus:outline-none focus:ring-1 focus:ring-olive" data-id="element-181" data-mp="2ewkh64p96lgz" />
    </div>;
}